// Design tokens extracted from Figma (initial subset)
// Source fonts observed: Atma (weights 400,600,700), Poppins (600), SF Pro / SF Compact (system fallback)
// Colors (subset) inferred from fills (#00462F, #E89B23, #FECC00, #2FC955, etc.)

export const palette = {
  primary: {
    main: '#064D00', // deep green from fills
    light: '#69B15E',
    dark: '#00462F',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#E89B23',
    light: '#FFBE58',
    dark: '#D48100',
    contrastText: '#040301',
  },
  brand: {
    green: '#064D00',
    orange: '#e89b23',
    yellow: '#FECC00',
    lightGreen: '#2FC955',
    blue: '#5A78FF',
  },
  success: { main: '#2FC955', contrastText: '#FFFFFF' },
  warning: { main: '#FECC00', contrastText: '#040301' },
  error: { main: '#E34843', contrastText: '#FFFFFF' },
  info: { main: '#5A78FF', contrastText: '#FFFFFF' },
  text: {
    primary: '#040301',
    secondary: '#555555',
    disabled: '#9C9C9C',
  },
  background: {
    default: '#FAF7F6', // Solid/Green 100
    paper: '#FFFFFF',
  },
  divider: '#DBE1E6',
};

export const typography = {
  fontFamily: [
    'Atma',
    'Poppins',
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Roboto',
    'Helvetica Neue',
    'Arial',
    'sans-serif',
  ].join(','),
  h1: { fontFamily: 'Atma', fontWeight: 700, fontSize: '3rem', lineHeight: 1.2 },
  h2: { fontFamily: 'Atma', fontWeight: 700, fontSize: '2.25rem', lineHeight: 1.25 },
  h3: { fontFamily: 'Atma', fontWeight: 700, fontSize: '1.75rem', lineHeight: 1.3 },
  h4: { fontFamily: 'Atma', fontWeight: 700, fontSize: '1.5rem', lineHeight: 1.35 },
  h5: { fontFamily: 'Atma', fontWeight: 700, fontSize: '1.25rem', lineHeight: 1.4 },
  h6: { fontFamily: 'Atma', fontWeight: 600, fontSize: '1.05rem', lineHeight: 1.45 },
  body1: { fontFamily: 'Atma', fontWeight: 400, fontSize: '1rem', lineHeight: 1.6 },
  body2: { fontFamily: 'Atma', fontWeight: 400, fontSize: '0.875rem', lineHeight: 1.55 },
  button: { fontFamily: 'Poppins', fontWeight: 600, textTransform: 'none' },
};

export const shape = {
  borderRadius: 8,
};

export const shadows = {
  focus: '0px 0px 0px 3px rgba(232,155,35,0.4)',
};

export type DesignTokens = {
  palette: typeof palette;
  typography: typeof typography;
  shape: typeof shape;
  shadows: typeof shadows;
};

export const designTokens: DesignTokens = { palette, typography, shape, shadows };
